









import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class StatCard extends Vue {
  @Prop({ default: "grey" }) readonly color1!: string;
  @Prop({ default: "grey" }) readonly color2!: string;
  @Prop({ default: "" }) readonly subtitle!: string;
  @Prop({ default: "--" }) readonly title!: string;

  get cardStyle() {
    return `background: linear-gradient(0deg, ${this.color1}, ${this.color2});`;
  }
}
